import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ServiceTemplateScheduleOccurrenceRow } from "../serviceTemplateScheduleOccurrencesViewConfig";
import { ServiceTemplateScheduleOccurrenceMemberCell } from "./ServiceTemplateScheduleOccurrenceMemberCell";

export const ServiceTemplateScheduleOccurrenceManagerCell = memo(
    ({
        row,
        table,
    }: CellContext<
        ViewTableFeatures,
        ServiceTemplateScheduleOccurrenceRow,
        number | null
    >) => (
        <ServiceTemplateScheduleOccurrenceMemberCell
            row={row}
            table={table}
            field="managerId"
            addText="Assign manager"
            emptyLabel="No manager"
        />
    ),
);

ServiceTemplateScheduleOccurrenceManagerCell.displayName =
    "ServiceTemplateScheduleOccurrenceManagerCell";
